export enum SortDirection {
  Desc = -1,
  Asc = 1,
  Unsorted = 0
}